import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import {
  setFooterBottomSpacing,
  setRoute,
  toggleRedirectNotFound,
  handleLoadDepartaments,
  handleLoadCities,
  onUpdateCarts,
  toggleLoadingProduct,
} from "../../redux/actions";
import { useParams } from "react-router-dom";
import {
  callDataProductInfo,
  handleLoadErrorQuote,
  handleResetQuote,
} from "../../redux/actions";
import { path } from "../../config/enviroment";
import { Body, WhiteContainer } from "../../theme/theme";
import BreadCrumb from "../../components/BreadCrumb";
import RelatedProducts from "../../components/RelatedProducts";
import { getCategoryname } from "../../utils/getNameById";
import { ProductImgContent, ProductDataContent } from "./utils";
import { ProductContainer, LoadContainer } from "./style";
import Spinner from "../../components/Spinner";
import { useUrl } from "../../hooks/useUrl";
import { useWhatsAppButtonPosition } from "../../hooks/useWhatsAppButtonPosition";
import { language } from "../../utils/language";
import { locateImage } from "../../helpers/imageExists";
import FreeShippingMinBanner from "../../components/FreeShippingMinBanner";

const ProductInfo = (props: any) => {
  const homeState: HomeStateType = useSelector(
    (state: RootState) => state.home
  );
  const categoryState: any = useSelector((state: RootState) => state.category);
  const productState: any = useSelector((state: RootState) => state.product);
  const elogisticaState: any = useSelector(
    (state: RootState) => state.elogistica
  );
  const shoppingCart: ShoppingCartStateType = useSelector(
    (state: RootState) => state.shoppingCart
  );
  const dispatch = useDispatch();
  const { idProduct, idCatalog, idCategory }: IParams = useParams();
  const [operator, setOperator] = useState("");
  const [codigo, setCodigo] = useState("");
  const [refSelect, setRefSelect] = useState<any>(null);
  const [refIdOptional, setRefIdOptional] = useState(null);
  const [availableReferences, setAvailableReferences] = useState<any>(null);
  const [images, setImages] = useState<Array<string>>([]);

  const shortUrl = useUrl(
    window.location.hostname === "localhost"
      ? `${path}product-info/${idCategory}/${idProduct}`
      : window.location.href
  );

  useEffect(() => {
    const urlImages = async () => {
      setImages([]);
      const images = productState.productInfo?.img;
      if (images && images.length > 0) {
        for (const imagePath of images) {
          const imageUrl = await locateImage(imagePath);
          setImages((prevImages) => [...prevImages, imageUrl]);
        }
      }
    };
    urlImages();
  }, [productState.productInfo?.img]);

  useEffect(() => {
    if (shoppingCart.refId !== null) {
      setRefIdOptional(shoppingCart.refId);
    }
    loadDataProduct();
    if (
      elogisticaState.editProd == null ||
      elogisticaState.editProd !== idProduct
    ) {
      dispatch(handleLoadErrorQuote(""));
      dispatch(handleResetQuote());
      setOperator("");
      setCodigo("");
    }
  }, [idProduct]);

  useEffect(() => {
    if (elogisticaState.departaments.length === 0) {
      dispatch(handleLoadDepartaments());
    }
    if (elogisticaState.cities.length === 0) {
      dispatch(handleLoadCities());
    }
  }, []);

  const loadDataProduct = async () => {
    if (shoppingCart.update) {
      dispatch(toggleLoadingProduct(true));
      shoppingCart.cartInfo.forEach((value: any) => {
        if (value.references && value.references.length > 0) {
          //WE VERIFY IF THE PRODUCT HAS REFERENCES
          value.references.forEach((ref: any) => {
            ref.finalQuantity = Math.abs(
              parseInt(ref.quantity) - parseInt(ref.initialQuantity)
            );
            ref.action =
              ref.quantity > ref.initialQuantity ? "substract" : "add";
          });
        } else {
          //OTHERWISE
          value.finalQuantity = Math.abs(
            parseInt(value.quantity) - parseInt(value.initialQuantity)
          );
          value.action =
            value.quantity > value.initialQuantity ? "substract" : "add";
        }
      });
      const data: any = {
        url: path,
        products: shoppingCart.cartInfo,
        origin: "epayco",
      };

      if (shoppingCart.id) {
        data.shoppingCartId = shoppingCart.id;
      }
      await onUpdateCarts(data, dispatch, homeState.default_language);
    }
    dispatch(
      callDataProductInfo(
        path,
        idProduct,
        homeState.manage,
        homeState.default_language
      )
    );
  };

  useEffect(() => {
    dispatch(
      setRoute({
        route: "/",
        routeName:
          productState.loading || productState.productInfo === null
            ? language[homeState.default_language]["loading"]
            : productState.productInfo.title,
      })
    );
    if (
      productState.productInfo === null &&
      !productState.loading &&
      productState.redirectNotFound
    ) {
      props.history.push(`/vende/${homeState.catalogueUrlName}/error`);
      dispatch(toggleRedirectNotFound(false));
    }
  }, [productState]);

  useWhatsAppButtonPosition("6.5rem");

  const initRefSelect = () => {
    if (
      productState.productInfo.setupReferences &&
      productState.productInfo.setupReferences.length > 0 &&
      refSelect === null
    ) {
      const references = productState.productInfo.setupReferences.map(
        (item: any) => {
          return null;
        }
      );
      setRefSelect(references);
    }
  };

  const initValidateRefAvailability = () => {
    if (
      productState.productInfo.setupReferences &&
      productState.productInfo.setupReferences.length > 0 &&
      refSelect === null
    ) {
      const available = productState.productInfo.references.map((item: any) => {
        return {
          reference: item.name,
          available: item.available,
          features: item.name.split("/"),
        };
      });
      setAvailableReferences(available);
    }
  };

  useEffect(() => {
    if (
      !productState.loading &&
      productState.productInfo !== null &&
      productState.productInfo.id == idProduct
    ) {
      dispatch(setFooterBottomSpacing("3rem"));
      initRefSelect();
      initValidateRefAvailability();
    } else {
      setRefSelect(null);
    }

    return () => {
      dispatch(setFooterBottomSpacing(undefined));
    };
  }, [productState.loading, productState.productInfo]);

  useEffect(() => {
    if (
      elogisticaState.selectedCity.codigoDane !== 0 &&
      elogisticaState.requestQuote.length > 0
    ) {
      setCodigo(elogisticaState.selectedCity.codigoDane);
      setOperator(elogisticaState.requestQuote[0].operador);
    }
  }, [elogisticaState.selectedCity.codigoDane]);

  useEffect(() => {
    if (elogisticaState.errorQuote !== "") {
      setOperator("");
    }
  }, [elogisticaState.errorQuote]);

  return (
    <Body>
      {productState.loading || productState.productInfo === null ? null : (
        <BreadCrumb
          linkName1={language[homeState.default_language]["categories2"]}
          linkroute1={`vende/${homeState.catalogueName}/categories`}
          linkName2={getCategoryname(
            productState.productInfo.categories[0],
            categoryState.listCategory,
            homeState.default_language
          )}
          linkroute2={`vende/${homeState.catalogueName}/detailCategory/${productState.productInfo.categories[0]}`}
          currentPage={productState.productInfo.title}
        />
      )}
      <FreeShippingMinBanner inContent />
      {productState.loading ||
      productState.productInfo === null ||
      shortUrl === null ||
      (operator !== "" &&
        elogisticaState.requestQuote.length === 0 &&
        elogisticaState.errorQuote === "") ? (
        <LoadContainer>
          <Spinner color={homeState.color} />
        </LoadContainer>
      ) : (
        <WhiteContainer>
          <ProductContainer>
            <ProductImgContent
              product={productState.productInfo}
              images={images}
              amount={
                productState.productInfo.netAmount !== 0
                  ? productState.productInfo.netAmount
                  : productState.productInfo.amount
              }
              discountPrice={productState.productInfo.discountPrice}
              discountRate={productState.productInfo.discountRate}
              refSelect={refSelect}
            />
            <ProductDataContent
              idCatalog={idCatalog}
              product={productState.productInfo}
              color={homeState.color}
              shortUrl={shortUrl}
              codigo={codigo}
              setCodigo={(value: any) => setCodigo(value)}
              resetOperator={(value: string) => {
                setOperator(value);
              }}
              refSelect={refSelect}
              setRefSelect={(value: any) => setRefSelect(value)}
              availableReferences={availableReferences}
              refIdOptional={refIdOptional}
            />
          </ProductContainer>
          <RelatedProducts />
        </WhiteContainer>
      )}
    </Body>
  );
};

export default ProductInfo;
